export const getErrorMessage = (error, fallbackMessage) => {
  if (error?.response?.data?.message) {
    return error.response.data.message;
  }
  if (error?.response?.data?.status_message) {
    return error.response.data.status_message;
  }
  if (error?.response?.data?.error) {
    return error.response.data.error;
  }

  if (error?.response?.data?.errors) {
    const errors = error.response.data.errors;
    if (Array.isArray(errors) && errors.length > 0) {
      return errors.map((err) => err.message || err).join(', ');
    }
  }

  if (error?.code === 'NETWORK_ERROR' || error?.message?.includes('Network Error')) {
    return 'Network error. Please check your connection and try again.';
  }

  if (error?.code === 'ECONNABORTED' || error?.message?.includes('timeout')) {
    return 'Request timeout. Please try again.';
  }

  if (error?.response?.status) {
    const status = error.response.status;
    if (status === 401) return 'Unauthorized. Please login again.';
    if (status === 403) return 'Access denied. You do not have permission to perform this action.';
    if (status === 404) return 'Resource not found.';
    if (status === 500) return 'Server error. Please try again later.';
    if (status >= 400 && status < 500) return 'Invalid request. Please check your input.';
    if (status >= 500) return 'Server error. Please try again later.';
  }

  if (error?.message) {
    return error.message;
  }

  return fallbackMessage || 'An unexpected error occurred. Please try again.';
};
